import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

import {
  entityType,
  connectedDictionaryType,
  fieldsType,
  dictionaryType,
} from 'types';
import ConnectedDictionaryComponent from './components/ConnectedDictionary';
import './style.scss';

class ConnectedDictionariesList extends Component {
  static propTypes = {
    allDictionaries: PropTypes.arrayOf(dictionaryType),
    currentEntity: entityType,
    fields: fieldsType,
    formValues: entityType,
    getAllDictionaries: PropTypes.func,
    isLoadingAllDictionaries: PropTypes.bool,

    // redux-form
    items: PropTypes.arrayOf(connectedDictionaryType),
    onConnect: PropTypes.func,
  };

  renderEmptyView = () => {
    const { currentEntity, onConnect, fields } = this.props;
    if (fields.length) {
      return null;
    }
    return (
      <EmptyView styleName="empty-view">
        <p>
          The entity is not yet linked.{' '}
          {!currentEntity.archived && (
            <Button
              isLink
              data-test="link-entity-with-dictionary"
              onClick={onConnect}
            >
              Link your entity with one or more dictionaries
            </Button>
          )}
        </p>
      </EmptyView>
    );
  };

  render() {
    const {
      currentEntity,
      items,
      getAllDictionaries,
      allDictionaries,
      fields,
      formValues,
      isLoadingAllDictionaries,
    } = this.props;
    return (
      <div styleName="dictionary-wrap">
        {this.renderEmptyView()}
        {fields &&
          fields.map((field, index) => (
            <ConnectedDictionaryComponent
              key={`${field}`}
              allDictionaries={allDictionaries}
              currentEntity={currentEntity}
              fields={fields}
              formValues={formValues}
              getAllDictionaries={getAllDictionaries}
              index={index}
              isLoadingAllDictionaries={isLoadingAllDictionaries}
              item={fields.get(index)}
              items={items}
              name={`${field}`}
            />
          ))}
      </div>
    );
  }
}

export default ConnectedDictionariesList;
